module.exports = __webpack_public_path__ + "components/smartbar/static/smartbanner-icon-de238040a5101f757f67412f6f95681d.png";